module.exports = __webpack_public_path__ + "img/UserCircle.07dff6b3.svg";